import {ErrorMessage, Field} from 'formik';
import {useState} from 'react';
import TermsModal from '../components/TermsModal';

const EmailStep = ({formik}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Make sure formik is defined before accessing its properties
  if (!formik) {
    return <div>Loading...</div>;
  }

  return (
    <div className="registration-form">
      <h2 className="text-white" style={{fontSize: '20px'}}>
        Sign up to Mapex.app
      </h2>
      <p className="text-white-50 mb-3" style={{fontSize: '10px'}}>
        Already have an account?{' '}
        <a href="#" className="text-primary">
          Log in
        </a>
      </p>

      <div className="mb-3">
        <Field
          type="email"
          name="email"
          className="form-control text-white border-0 py-3 gn-input-class"
          placeholder="AlexaAlexander@gmail.com"
          style={{
            background: 'rgba(251, 251, 251, 0.1)',
          }}
        />
        <ErrorMessage
          name="email"
          component="div"
          className="text-danger mt-1"
          style={{fontSize: '10px'}}
        />
      </div>

      <div className="form-check mb-3 flex justify-content-center align-items-center">
        <Field
          type="checkbox"
          name="receiveOffers"
          className="form-check-input"
          id="receiveOffers"
        />
        <p
          className="form-check-label text-white-50"
          htmlFor="receiveOffers"
          style={{fontSize: '9px', color: '#5B5B5B'}}
        >
          I'll like to receive an offers and updates from mapex.app
        </p>
      </div>

      <button
        type="submit"
        className="btn btn-primary w-100 py-3 mb-3"
        style={{
          backgroundColor: '#2E2CB2',
          border: 'none',
          fontSize: '13px',
        }}
        disabled={formik.isSubmitting}
      >
        Create New Account
      </button>

      <p className="text-white-50 text-center small" style={{fontSize: '10px', lineHeight: '15px'}}>
        By According you email, you conform that{' '}
        <a href="/" className="text-primary">
          matrixapex.io
        </a>
      </p>

      <div className="dropdown mt-3 flex justify-center">
        <div className="flex flex-row justify-between items-center bg-dark text-white text-[10px] py-[11px] px-[19px] rounded-5">
          <div>
            <Field
              type="text"
              name="referalCode"
              className="text-white text-[10px] border-0 h-full w-full min-w-[165px]"
              placeholder="Referral Code (Optional)"
              style={{
                outline: 'none',
                fontSize: 10,
              }}
            />
          </div>
          <div>
            <svg
              width="11"
              height="5"
              viewBox="0 0 11 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5.5 5L0.5 0H10.5L5.5 5Z" fill="#5B5B5B" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailStep;
